export { Features } from './Features';
export { GetApp } from './GetApp';
export { Presentation } from './Presentation';



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/sections/index.ts